import React, {Suspense, useContext, useEffect, useState} from 'react';
import { useT } from '../../../../../helpers/i18n';
import {useSelector, useStore} from 'react-redux';

import Checkers from '../../../../../helpers/class/Checkers';

import DetailDescViewPort from './left/DetailDescViewPort';
import FeaturedImagesViewPort from './left/FeaturedImagesViewPort';
import FeaturesViewPort from './left/FeaturesViewPort';
import ServicesViewPort from './left/ServicesViewPort';
import SpacesViewPort from './left/SpacesViewPort';
import ThemesViewPort from './left/ThemesViewPort';
import {useIsSSR} from "@react-aria/ssr";
import TermsViewPort from "./left/TermsViewPort";
import PropertyHeading from "./left/PropertyHeadingDescViewPort";
import {fetchBuilderSettingByKey} from "../../../../../helpers/MethodHelper";
import ModalPois from "../../partials/modals/ModalPois";
import ArticleCategoriesContainer from "../../../articles/ArticleCategoriesContainer";
import {ExperiencesDestination} from "./left/ExperiencesDestination";
import {RelatedProperties} from "./left/RelatedProperties";
import Highlights from "./right/HighlightsViewPort";
import Skeleton from "react-loading-skeleton";
import {MediaSection} from "./left/MediaSection";
import BedroomDetails from './left/BedroomsView';
import SinglePropertyData from './left/ChainPropertyData';
import BedroomsView from "./left/BedroomsView";
import SinglePropertyContactForm from '../../../../contact/SinglePropertyContactForm';
import ChainPropertyData from './left/ChainPropertyData';
import LegalLicenseViewPort from "./left/LegalLicenseViewPort";
import B2BDescViewPort from './left/B2BDescViewPort';

export default function LeftSide ( props ) {
  const t = useT();
    const isServer = useIsSSR();

    const isPublicDomain = useSelector(state => state['appSettings']['isPublicDomain'])

    const isBookingsActive = useSelector(state => (state['appSettings']['isBookingsActive']==1 && fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_bookings_activate')==1) ? 1 : 0);

    const isHotel = useSelector(state => state['appSettings']['isHotel'])

    const isChain = useSelector(state => Checkers.valueToBoolean(state['appSettings']['isChain']))

    const factsheetDocument = props.details.hasOwnProperty('factsheet_document') ? props.details.factsheet_document : null

    const threesixtyTour = props.details.hasOwnProperty('threesixty_tour') ? props.details.threesixty_tour : null

    const experiences = props.details.experiences

    let show_themes = true;

    if (props.builder != null && Checkers.objChildExists(props.builder, 'builder_property_page_cat_show')) {
        show_themes = Checkers.valueToBoolean(props.builder.builder_property_page_cat_show);
    }

    const spaces_obj = {
        areaSqm: props.details.property_area_sqm,
        areaOutdoorSqm: props.details.property_area_outdoor_sqm,
        spaces: props.spaces,
    }

    const bookingBoxPosition = props.app.builder.builder_singleproperty_booking_box_position


    const singlePropertyData = useSelector(state => state['singlePropertyData']['propertyData'])

    const chainId = singlePropertyData && singlePropertyData.chain_id ? singlePropertyData.chain_id : null

    const [chain, setChain] = useState(chainId)

    useEffect(() => {
        setChain(chainId)

    }, [chainId])

    let mainClass = 'col-12 col-lg-8 p-t-20'
    if (props.hideSidebar || isPublicDomain == 1 || isBookingsActive == 0 || isHotel || isChain) {
        mainClass = 'col-12 col-lg-12 p-t-20'
    }
    if (bookingBoxPosition == 'FIXED') {
        mainClass = 'offset-1 col-10 col-lg-10 p-t-20'
    }

    const titlePositionBeforeJumbotron = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_title_position')
    );

    const moveRelatedPropertiesBelowMap = useSelector(
        state => Checkers.valueToBoolean(fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_related_properties_move_below_map'))
    );

    const areasLayoutSetting = useSelector(state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_layout'));

    const featuresBlock = !isChain ?
        <FeaturesViewPort app={props.app}
                          features={props.features}
                          fourColumns={props.fourColumnsFeatures}
                          isManager={props.app_data?.is_manager}
        />
        :
        <></>;

    const roomTypesAfterOverview = isHotel && props.overviewBeforeSpaces != null && !moveRelatedPropertiesBelowMap;

    // Related properties always close the content, right above the map (not between room types / chain properties)
    const showRelatedProperties = !moveRelatedPropertiesBelowMap && !props.isSingleVilla || isChain;
    const relatedPropertiesSectionActive = props.app.propertySections.some((section) => section.type == 'SYSTEM_PROPERTY_RELATED_PROPERTIES' && section.isActive);
    const relatedPropertiesBlock =
        <RelatedProperties propertyId={props.property_id} app_data={props.app_data}
                           app={props.app} builder={props.builder} isHotel={false} isChain={false} />;

    return (
        <div className={!chainId ? mainClass : 'col-12 col-lg-12 p-t-20'}>
            {
                props.app.propertySections.length == 0 ?
                    <>
                        {
                            !props.hideDescription && titlePositionBeforeJumbotron != 1 ?
                                <PropertyHeading
                                    details={props.details}
                                    location={props.location}
                                    readMore={props.details.desc_brief != null || props.details.desc_details != null}
                                    isChain={isChain}
                                />
                                :
                                <></>
                        }
                       {
                           !isChain && !props.hideDescription ?
                           <DetailDescViewPort details={props.details}
                                               location={props.location}
                                               readMore={props.details.desc_brief != null || props.details.desc_details != null}
                           /> : <></>
                       }
                        {/*<HighlightsViewPort highlights={props.highlights}/>*/}
                        {
                            show_themes && !isChain && !props.hideThemes ?
                            <ThemesViewPort
                                themes={props.themes}
                            /> : <></>
                        }
                        {/* multi units: the room types right under the description (the homepage has them under the overview) */}
                        {
                            isHotel && !roomTypesAfterOverview && !moveRelatedPropertiesBelowMap ?
                                <BedroomsView isHotel={true} locationLabel={props.location?.address} isManager={props.app_data?.is_manager} />
                                :
                                <></>
                        }
                        {
                        !isChain && !props.hideFeaturedImages ?
                                <FeaturedImagesViewPort images={props.images}
                                                        images_count={props.images_count}
                                                        all_images={props.all_images}
                                />
                                :
                                <></>
                        }
                        {
                            !isChain && !props.mediaAfterPolicies && !props.hideMedia ?
                                <MediaSection factsheetDocument={factsheetDocument}
                                                  threesixtyTour={threesixtyTour}
                                />
                                :
                                <></>
                        }
                        {props.profileBeforeSpaces || <></>}
                        {props.galleryAfterProfile || <></>}
                        {props.distinctsBeforeAttributes || <></>}
                        {props.overviewBeforeSpaces || <></>}
                        {
                            roomTypesAfterOverview ?
                                <BedroomsView isHotel={true} locationLabel={props.location?.address} isManager={props.app_data?.is_manager} />
                                :
                                <></>
                        }
                        {isHotel ? featuresBlock : <></>}
                        {
                            Checkers.displaySpaces(spaces_obj, areasLayoutSetting) && !isChain ?
                            <SpacesViewPort
                                areaSqm={spaces_obj.areaSqm}
                                areaOutdoorSqm={spaces_obj.areaOutdoorSqm}
                                spaces={spaces_obj.spaces}
                                isHotel={props.isHotel}
                            /> : <></>
                        }
                        {!isHotel ? featuresBlock : <></>}
                        {
                            !isChain ?
                                <ServicesViewPort services={props.services}
                                                  page_title={props.page_title}
                                                  isManager={props.app_data?.is_manager}
                                />
                                :
                                <></>
                        }
                        {/*{*/}
                        {/*    <>*/}
                        {/*        <div id="pro_distances_section" className="pb-5">*/}
                        {/*            <h2 className="m-t-5">{t('property.distances')}</h2>*/}
                        {/*            <ModalPois descAreaDistances={Checkers.isValidObjString(props.details, 'desc_area_distances') && props.details.desc_area_distances} map_pois={props.map_pois} />*/}
                        {/*        </div>*/}
                        {/*    </>*/}
                        {/*}*/}
                        {
                            !props.hideTerms && props.terms != undefined && props.terms.length > 0 && props.app.propertySections.length > 0?
                                <TermsViewPort  terms={props.terms} descRules={props.details.desc_rules}/>
                                :
                                <></>
                        }
                        {
                            !isChain && props.mediaAfterPolicies && !props.hideMedia ?
                                <MediaSection factsheetDocument={factsheetDocument}
                                                  threesixtyTour={threesixtyTour}
                                />
                                :
                                <></>
                        }

                        {!isChain && !props.hideExperiences ? <ExperiencesDestination experiences={experiences} app_data={props.app_data} app={props.app}
                                                builder={props.builder}/> : <></>}

                        {/*<BedroomHotel />*/}

                        {
                            !moveRelatedPropertiesBelowMap ?
                                <>
                                    {
                                        isChain ?
                                            <ChainPropertyData isChain={isChain}/>
                                            :
                                            <></>
                                    }
                                </>
                                :
                                <></>
                        }
                        {/* {
                            !moveRelatedPropertiesBelowMap ?
                                <>
                                    <>{!isChain ? <SinglePropertyContactForm/> : <></>}</>
                                </>
                                :
                                <></>
                        } */}
                        {showRelatedProperties ? relatedPropertiesBlock : <></>}
                    </>
                    :
                    <>
                        {
                            !props.hideDescription && titlePositionBeforeJumbotron != 1 ?
                                <PropertyHeading
                                    details={props.details}
                                    location={props.location}
                                    readMore={props.details.desc_brief != null || props.details.desc_details != null}
                                    isChain={isChain}
                                />
                                :
                                <></>
                        }
                        {
                            props.app.propertySections.map((section) => {

                                if (!section.isActive) {
                                    return (
                                        <></>
                                    )
                                }

                                switch (section.type) {
                                    case 'SYSTEM_PROPERTY_THEMES': {
                                        return (
                                            show_themes && !isChain && !props.hideThemes ?
                                            <ThemesViewPort
                                                themes={props.themes}
                                            /> : <></>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_B2B_DESCRIPTION': {
                                        return (
                                            props.hideDescription ? <></> :
                                            <>
                                                <B2BDescViewPort
                                                    details={props.details}
                                                    passwordEnabled = {props.app.builder.builder_properties_lock}
                                                />
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_DESCRIPTION': {
                                        return (
                                            props.hideDescription ? <></> :
                                            <>
                                                <DetailDescViewPort
                                                    details={props.details}
                                                    location={props.location}
                                                    readMore={props.details.desc_brief != null || props.details.desc_details != null}
                                                />
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_GALLERY': {
                                        return (
                                            <>
                                            {!isChain && !props.hideFeaturedImages ? <FeaturedImagesViewPort
                                                images={props.images}
                                                images_count={props.images_count}
                                                all_images={props.all_images}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_MEDIA': {
                                        return (
                                            <>
                                            {!isChain && !props.hideMedia ? <MediaSection factsheetDocument={factsheetDocument}
                                                          threesixtyTour={threesixtyTour}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_HIGHLIGHTS': {
                                        return (
                                            <>
                                            {!isChain ?<Highlights highlights={props.highlights}/> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_SPACES': {
                                        return (
                                            <>
                                            {!isChain ? Checkers.displaySpaces(spaces_obj, areasLayoutSetting) &&
                                            <SpacesViewPort
                                                areaSqm={spaces_obj.areaSqm}
                                                areaOutdoorSqm={spaces_obj.areaOutdoorSqm}
                                                spaces={spaces_obj.spaces}
                                                isHotel={props.isHotel}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_AMENITIES': {
                                        return (
                                            <>
                                           {!isChain ? <FeaturesViewPort
                                                app={props.app}
                                                features={props.features}
                                                isManager={props.app_data?.is_manager}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_SERVICES': {
                                        return (
                                            <>
                                            {!isChain ? <ServicesViewPort
                                                services={props.services}
                                                page_title={props.page_title}
                                                isManager={props.app_data?.is_manager}
                                            /> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_TERMS': {
                                        return (
                                            <>
                                            {!isChain && !props.hideTerms && props.terms && props.app.propertySections.length > 0 ?  <TermsViewPort terms={props.terms} descRules={props.details.desc_rules}/> : <></>}
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_DISTANCES': {
                                        return (
                                            <>
                                                {
                                                    (Checkers.isValidObjString(props.details, 'desc_area_distances') && props.details.desc_area_distances) || Checkers.isValidArray(props.map_pois) ?
                                                        <>
                                                            <div id="pro_distances_section" className="pb-5">
                                                                <h2 className="m-t-5">{t('property.distances')}</h2>
                                                                <ModalPois
                                                                    descAreaDistances={Checkers.isValidObjString(props.details, 'desc_area_distances') && props.details.desc_area_distances}
                                                                    map_pois={props.map_pois}/>
                                                            </div>
                                                        </>
                                                        :
                                                        <>
                                                        </>
                                                }
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_EXPERIENCES': {
                                        return (
                                            props.hideExperiences ? <></> :
                                            <>
                                                <ExperiencesDestination experiences={experiences}
                                                                        app_data={props.app_data} app={props.app}
                                                                        builder={props.builder}/>
                                            </>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_RELATED_PROPERTIES': {
                                        // rendered after all sections, see relatedPropertiesBlock
                                        return (
                                            <></>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_ROOM_TYPES': {
                                        return (
                                            !moveRelatedPropertiesBelowMap ?
                                                <>
                                                    {isHotel ? <BedroomsView isHotel={true} locationLabel={props.location?.address} isManager={props.app_data?.is_manager} /> : <></>}
                                                </>
                                                :
                                                <></>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_CHAIN_PROPERTIES': {
                                        return (
                                            !moveRelatedPropertiesBelowMap ?
                                                <>{isChain ? <ChainPropertyData isChain={isChain}/> : <></>}</>
                                                :
                                                <></>
                                        )
                                    }
                                    case 'SYSTEM_PROPERTY_LEGAL_LICENSE': {
                                        return <LegalLicenseViewPort details={props.details} />
                                    }
                                    // case 'SYSTEM_PROPERTY_CONTACT_FORM': {
                                    //     return (
                                    //         !moveRelatedPropertiesBelowMap ?
                                    //             <>{!isChain ? <SinglePropertyContactForm /> : <></>}</>
                                    //             :
                                    //             <></>
                                    //     )
                                    // }
                                    default: {
                                        return (
                                            <></>
                                        )
                                    }
                                }
                            })
                        }
                        {showRelatedProperties && relatedPropertiesSectionActive ? relatedPropertiesBlock : <></>}
                    </>
            }
            {/*<SinglePropertyContactForm />*/}
        </div>
    )
}
